import React, {Component} from "react";
import {IMPORT, IMPORTING, MAX_FILE_SIZE, MAX_FILE_SIZE_STRING} from '../constants';
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {alertSuccess, getIdFromUrl, handleErr, showSpinner,} from "../utils/MiscellaniousUtils";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import {ExpandMore} from "@material-ui/icons";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ResourceAPIs from "../utils/ResourceAPI";

const MySwal = withReactContent(Swal);

class AmazonShipmentImporter extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedFile: null,
            fileErr: "",
            isProcessing: false,
            importBtnText: IMPORT,
            importStatus: "",
        };
    }

    onChangeHandler = event => {
        if (event.target.files[0] !== undefined) {
            if (this.isValidFileSize(event.target.files[0])) {
                this.setState({
                    selectedFile: event.target.files[0],
                    loaded: 0,
                })
            }
        }
    };

    isValidFileSize = (files) => {
        for (let i = 0; i < files.length; i++) {
            if (files[i].size > MAX_FILE_SIZE) {
                MySwal.fire("File '" + files[i].name + "' size Exceeds",
                    "Please add a file less than " + MAX_FILE_SIZE_STRING + " size", "error");
                this.setState({
                    selectedFile: [],
                });
                return false;
            }
        }
        return true;
    };

    onClickHandler = () => {
        const data = new FormData();
        data.append('file', this.state.selectedFile);

        if (this.validateInputs()) {
            this.setState({
                importBtnText: IMPORTING,
                isProcessing: true,
            });
            new ResourceAPIs().importAmazonShipmentSplitContents(getIdFromUrl(), data)
                .then(res => {
                        this.props.setIsSplitContentsImported(true);
                        this.setState({
                            importBtnText: IMPORT,
                            isProcessing: false,
                        });
                        this.clearFrom();
                        alertSuccess(res.data);
                    })
                .catch(error => {
                        handleErr(error);
                        this.setState({
                            importBtnText: IMPORT,
                            isProcessing: false,
                        });
                    }).then(
                this.props.setIsSplitContentsImported(false)
            );
        }
    };

    validateInputs = () => {
        if (this.state.selectedFile == null) {
            this.setState({
                fileErr: "Pls select the file you want to upload!",
            });
            return false;
        } else {
            this.setState({
                fileErr: "",
            });
        }
        return true;
    };

    clearFrom = () => {
        this.setState({
            selectedFile: null,
        });
    };

    render() {
        return (
            <div>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMore/>}
                        aria-controls="panel1a-content"
                        id="panel1a-header">
                        <span style={{color: '#32a2fe'}}>Amazon Shipment Importer</span>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Row>
                            <div>
                                <Form.Group as={Col} controlId="formGridState">
                                    <Form.Label>Select File</Form.Label>
                                    <br/>
                                    <input type="file" name="file" onChange={this.onChangeHandler}/>
                                    <Form.Text className="text-muted">
                                        {this.state.fileErr}
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group as={Col} controlId="formGridState">
                                    <Row>
                                        <Col>
                                            <Button variant="success" onClick={this.onClickHandler}
                                                    disabled={this.state.isProcessing}>
                                                {showSpinner(this.state.importBtnText)}
                                            </Button>
                                        </Col>
                                        <Col>
                                            {this.state.importStatus}
                                        </Col>
                                    </Row>
                                </Form.Group>
                            </div>
                        </Row>
                    </AccordionDetails>
                </Accordion>
            </div>
        );
    }
}

export default AmazonShipmentImporter;
